var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "woot-modal",
    {
      attrs: { show: _vm.show, "on-close": _vm.onCancel },
      on: {
        "update:show": function($event) {
          _vm.show = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "column content-box" },
        [
          _c("woot-modal-header", {
            attrs: {
              "header-title": _vm.$t("NEW_CONVERSATION.TITLE"),
              "header-content": _vm.$t("NEW_CONVERSATION.DESC")
            }
          }),
          _vm._v(" "),
          _c("conversation-form", {
            attrs: { contact: _vm.contact, "on-submit": _vm.onSubmit },
            on: { success: _vm.onSuccess, cancel: _vm.onCancel }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }